import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import MeterReadingsLayer from "../components/MeterReadingsLayer";

const MeterReadingsPage = () => {
  return (
    <>
      <MasterLayout pageTitle="Meter Readings">
        <MeterReadingsLayer />
      </MasterLayout>
    </>
  );
};

export default MeterReadingsPage;
